<form #emailsForm="ngForm">
  <div class="toolbar">
    <span>
      <button matButton="text" (click)="backToOrganizationDetail()">
        <span>
          <mat-icon class="size-16">keyboard_arrow_left</mat-icon>
          <label>Back To Organization</label>
        </span>
      </button>
    </span>
    <span class="spacer"></span>
    <span>
      @if (!isNew() && selectedEmail) {
        <button matButton="text" (click)="deleteEmail()">
          <span>
            <mat-icon class="size-16">remove</mat-icon>
            <label>Delete</label>
          </span>
        </button>
      }
      @if (!isNew()) {
        <button matButton="text" (click)="newEmail()">
          <span>
            <mat-icon class="size-16">add</mat-icon>
            <label>New</label>
          </span>
        </button>
      }
      <button matButton="text" [disabled]="!selectedEmail || emailsForm.invalid" (click)="save()">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label>Save</label>
        </span>
      </button>
    </span>
  </div>
  <div class="emailsWrapper">
    <div class="leftColumn">
      <table class="reportTable">
        <thead>
          <tr>
            <td class="tableCell headerCell">Type</td>
            <td class="tableCell headerCell">Address</td>
          </tr>
        </thead>
        @if (emails() && emails().length > 0) {
          @for (email of emails(); track email; let rowIndex = $index) {
            <tr [class.selectedRow]="rowIndex === selectedRowId()" class="selectableRow" (click)="selectEmail(rowIndex, email)">
              <td class="tableCell">{{ email.relationshipTypeDescription }}</td>
              <td class="tableCell">{{ email.emailAddress }}</td>
            </tr>
          }
        }
        @if (!emails() || emails().length === 0) {
          <tr>
            <td class="tableCell centeredCell" colspan="2">No emails found</td>
          </tr>
        }
      </table>
    </div>
    <div class="rightColumn">
      @if (selectedEmail) {
        <table>
          <tr>
            <td class="labelColumn">
              <label for="emailTypeSelection">Email Type:</label>
            </td>
            <td class="inputColumn">
              <select name="emailTypeSelection" id="emailTypeSelection" class="inputField" [(ngModel)]="selectedEmail.relationshipTypeCode">
                @for (emailType of emailTypes(); track emailType) {
                  <option [value]="emailType.code">{{ emailType.description }}</option>
                }
              </select>
            </td>
          </tr>
          <tr>
            <td class="labelColumn">
              <label for="emailAddressInput">Email Address:</label>
            </td>
            <td class="inputColumn">
              <input id="emailAddressInput" name="emailAddressInput" maxlength="250" class="inputField standardTextBox" [ngClass]="{'inputError': emailAddressInput.invalid}" required [(ngModel)]="selectedEmail.emailAddress"
                #emailAddressInput="ngModel"/>
            </td>
          </tr>
        </table>
      }
    </div>
  </div>
</form>
